import { Button, Grid, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { EditIcon, OrganizationMembersIcon } from "src/grading/assets";
import { setCurrentOrgID } from "src/store/reducers/auth/authSlice";
import { setOrganization } from "src/store/reducers/organizations/organizationSlice";
import { Organization } from "src/store/reducers/organizations/organizationsApiSlice";
import OrgIcon from "../OrgIcon/OrgIcon";
import useStyles from "./OrgCard.styles";

interface OrganizationCardProps {
  organization: Organization;
}

const OrganizationCard = ({ organization }: OrganizationCardProps) => {
  const classes = useStyles();

  const history = useHistory();

  const dispatch = useDispatch();

  const handleEdit = () => {
    history.push(`/grading/admin/organizations/${organization.id}`);
  };

  return (
    <Grid container xs={12} className={classes.container}>
      <Grid container className={classes.orgIconContainer}>
        <OrgIcon organization={organization} />
        <Grid container item flex={0.9} className={classes.orgText}>
          <Typography variant="h4" fontWeight="bold" className={classes.text}>
            {organization.name}
          </Typography>
          <Typography variant="body1">{`Branch: ${organization.branchName}`}</Typography>
          <Typography variant="body2" mt={1}>
            {`Owner: ${organization.owner.name} | ${organization.owner.email}`}
          </Typography>
          <Grid container item mt={1} className={classes.membersTextContainer}>
            <OrganizationMembersIcon />
            <Typography variant="body2" ml={2}>
              {`${organization.memberCount} members`}
            </Typography>
          </Grid>
        </Grid>
        <Grid container item flex={0.1} style={{ justifyContent: "end" }}>
          <Button
            variant="contained"
            size="small"
            className={classes.actionButton}
            fullWidth
            onClick={handleEdit}
          >
            <EditIcon stroke="white" />
            Edit
          </Button>
          <Button
            variant="contained"
            size="small"
            className={classes.actionButton}
            fullWidth
            onClick={() => {
              dispatch(setCurrentOrgID(organization.id));
              dispatch(setOrganization({ organization }));
              history.push("/grading/organization");
            }}
          >
            Log In
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationCard;
